import { datadogLogs } from "@datadog/browser-logs"
import { datadogRum } from "@datadog/browser-rum"
import * as env from "lib/env"

export function initLogger(): void {
    if (env.ENV !== "local") {
        datadogLogs.init({
            clientToken: env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
            site: "datadoghq.com",
            forwardErrorsToLogs: true,
            sampleRate: 100,
        })

        datadogLogs.setGlobalContext({
            team: "flashy-jandals",
            service: "onboarding-hub",
            env: env.ENV,
            release: env.GITHUB_REF_NAME,
        })

        if (env.DATADOG_RUM_ENABLED) {
            datadogRum.init({
                env: env.ENV,
                version: env.GITHUB_REF_NAME,
                applicationId: env.DATADOG_RUM_APPLICATION_ID,
                clientToken: env.DATADOG_RUM_CLIENT_TOKEN,
                site: "datadoghq.com",
                service: "onboarding-hub",
                sessionSampleRate: 100,
                sessionReplaySampleRate: 20,
                tracingSampleRate: 100,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: "mask-user-input",
                allowedTracingOrigins: [env.ONBOARDING_API_URL],
                beforeSend: (event) => {
                    if (
                        event.type === "resource" &&
                        event.resource.url.includes("/notes") &&
                        event.resource.status_code === 404 &&
                        event.resource.method === "GET"
                    ) {
                        return false
                    }
                },
            })

            if (env.DATADOG_RUM_SESSION_REPLAY_ENABLED) {
                datadogRum.startSessionReplayRecording()
            }
        }
    }
}
